import type { ReactNode } from 'react'

import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'
import { ChevronDownIcon } from '@tribeplatform/react-ui-kit/icons'

interface GenericOperatorPickerProps {
  operatorName: string
  children: ReactNode
}
export const GenericOperatorPicker = ({
  operatorName,
  children,
}: GenericOperatorPickerProps) => {
  return (
    <Dropdown>
      <Dropdown.ButtonMinimal>
        <span className="inline-flex items-center hover:text-interactive-hovered text-content">
          {operatorName}
          <ChevronDownIcon className="w-4 h-4" />
        </span>
      </Dropdown.ButtonMinimal>
      <Dropdown.Items noWrapper className="absolute z-20">
        {children}
      </Dropdown.Items>
    </Dropdown>
  )
}
